import { render } from "./HistoryForm.vue?vue&type=template&id=55c53a50&ts=true"
import script from "./HistoryForm.vue?vue&type=script&lang=ts"
export * from "./HistoryForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__